import {
  BaseInputTemplateProps,
  InputTemplateRegistry,
} from "@graffer-inc/form-generator";
import {
  InputElementUnion,
  IRepeatableElement,
  isMyNumberInputElement,
} from "@graffer-inc/form-schema";
import * as React from "react";
import { DefaultConfirmInputTemplateRegistry } from "@graffer-inc/form-generator";
import { MyNumberViewInput } from "../components/mynumber-view-input";
import { NotificationNumberInput } from "../components/notification-number-input";

export class SmartApplyViewInputRegistry implements InputTemplateRegistry {
  get(
    elem: InputElementUnion,
    repeatable?: IRepeatableElement,
  ): React.ComponentType<BaseInputTemplateProps<any, any, any>> {
    if (isMyNumberInputElement(elem)) {
      return MyNumberViewInput;
    }
    if (elem.id === "notificationNumber") {
      return NotificationNumberInput;
    }
    return DefaultConfirmInputTemplateRegistry.get(elem, repeatable);
  }
}
